const state = {
  systemInfo: {},

  isAdmin: undefined,
  isNewUser: false,
  accountInfo: {},
  publicationInfo: {},
  publicationInfo: {},
  // 杂志内容管理
  notIncludedProviders: {},
  magazineList: [],
  magazineConfig: {},
  magazineInfo: {},
  columnKindList: null,
  // 题库相关的数据
  libInfo: {},
  libList: undefined,
  createStep: 1,
  // 提审模板相关数据
  templateId: 1126,
  extConfig: {
    window: {
      backgroundTextStyle: 'dark',
      backgroundColor: '#FFF',
      navigationBarBackgroundColor: '#fff',
      navigationBarTitleText: '',
      navigationBarTextStyle: 'black',
      navigationStyle: 'custom',
      enablePullDownRefresh: true,
      onReachBottomDistance: 800,
    },
    networkTimeout: {
      request: 20000,
      downloadFile: 60000,
    },
    ext: {
      copywriting: {
        itemName: '表态',
      },

      // 操作文案
      actions: {
        mark: '马克',
        vote: '投票',
      },

      // 版权信息
      articleCopyright: 'self',
      about: null,

      /** == 功能开关 == **/
      // 杂志
      enableMagazine: false,
      // 订阅杂志
      enableSubscribe: false,
      // 关注用户
      enableFollow: false,
      // 一起读
      enableDiscuss: true,
      /**
       * 是否可以发帖子
       * 公有杂志: 详情页的发帖按键(主要是轻芒杂志)
       * 私有杂志基本不吃这个控制
       */
      enableTopic: false,
      /**
       * 社群
       * if(true) 个人页面展示社群 tab, 杂志页展示 groupAction 组件(管理员固定展示 groupAction)
       *   这里是 groupAction 的组件判断条件
       *   if enablePost 展示发帖按钮(+)
       *   else if(stranger)
       *     if(actionType = protect) 不展示加入按钮
       *     else 展示加入按钮或者购买按钮
       * else 个人页面不展示社群 tab，杂志页不展示 groupAction 组件
       *
       * 其他影响： true 的时候会打开一个群组用的长链接，但其实服务器挂了很久了
       */
      enableGroup: false,
      /**
       * 支付
       * if(true) 个人页展示已购 tab 文章页会分析付费信息
       */
      enablePay: false,
      /**
       * 打赏
       * 没用，一直 false 吧，应该是没有跑通打赏流程
       */
      enableBonus: false,
      /**
       * 客服
       * explore 是否会展示 contact，一直 false 就好了。
       */
      enableContact: false,
      /**
       * 微信群列表
       * 只有小游玩家会开这个配置项，不要开
       */
      enableWechatGroup: false,
      /**
       * 插件登录
       */
      // enablePluginAuth: true,
    },
    debug: true,
  },
  transferExtConfig: {
    window: {
      backgroundTextStyle: 'dark',
      backgroundColor: '#FFF',
      navigationBarBackgroundColor: '#fff',
      navigationBarTitleText: '',
      navigationBarTextStyle: 'black',
      navigationStyle: 'custom',
      enablePullDownRefresh: true,
      onReachBottomDistance: 800,
    },
    networkTimeout: {
      request: 20000,
      downloadFile: 60000,
    },
    ext: {
      copywriting: {
        itemName: '讨论',
      },

      // 操作文案
      actions: {
        mark: '马克',
        vote: '投票',
      },

      // 版权信息
      articleCopyright: 'self',
      about: null,

      /** == 功能开关 == **/
      // 杂志
      enableMagazine: false,
      // 订阅杂志
      enableSubscribe: false,
      // 关注用户
      enableFollow: false,
      /**
       * 一起读 现在只控制了一起读
       */
      enableDiscuss: false,
      /**
       * 是否可以发帖子
       * 公有杂志: 详情页的发帖按键(主要是轻芒杂志)
       * 私有杂志基本不吃这个控制
       */
      enableTopic: false,
      /**
       * 社群
       * if(true) 个人页面展示社群 tab, 杂志页展示 groupAction 组件(管理员固定展示 groupAction)
       *   这里是 groupAction 的组件判断条件
       *   if enablePost 展示发帖按钮(+)
       *   else if(stranger)
       *     if(actionType = protect) 不展示加入按钮
       *     else 展示加入按钮或者购买按钮
       * else 个人页面不展示社群 tab，杂志页不展示 groupAction 组件
       *
       * 其他影响： true 的时候会打开一个群组用的长链接，但其实服务器挂了很久了
       */
      enableGroup: false,
      /**
       * 支付
       * if(true) 个人页展示已购 tab 文章页会分析付费信息
       */
      enablePay: false,
      /**
       * 打赏
       * 没用，一直 false 吧，应该是没有跑通打赏流程
       */
      enableBonus: false,
      /**
       * 客服
       * explore 是否会展示 contact，一直 false 就好了。
       */
      enableContact: false,
      /**
       * 微信群列表
       * 只有小游玩家会开这个配置项，不要开
       */
      enableWechatGroup: false,
    },
    debug: true,
  },
}

export default state
